import { createAction, props } from '@ngrx/store';
import { AppMenuItem } from '@webframework/client-core';

export const update = createAction('[Sidenav Item] Update', props<{ id: string; changes: Partial<AppMenuItem> }>());
export const select = createAction('[Sidenav Item] Select', props<{ payload: string | null }>());
export const click = createAction('[Sidenav Item] Click', props<{ payload: AppMenuItem }>());
export const toggle = createAction('[Sidenav Item] Toggle', props<{ payload: string }>());
export const custom = createAction('[Sidenav Item] Custom');
